module.exports = __webpack_public_path__ + "img/uid_tip_id.bdd2c2c.png";